import {
	BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM,
	BLOCK_ACTIONS_MENU_SECTION,
	BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM,
	BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM,
	DELETE_MENU_SECTION,
	DELETE_MENU_ITEM,
	POSITION_MENU_SECTION,
	POSITION_MOVE_UP_MENU_ITEM,
	POSITION_MOVE_DOWN_MENU_ITEM,
	TRANSFORM_MENU_SECTION,
	TRANSFORM_MENU_ITEM,
	TRANSFORM_CLEAR_MENU_SECTION,
	TRANSFORM_CLEAR_MENU_ITEM,
	TRANSFORM_CREATE_MENU_SECTION,
	TRANSFORM_HEADINGS_MENU_SECTION,
	TRANSFORM_HEADINGS_H1_MENU_ITEM,
	TRANSFORM_HEADINGS_H2_MENU_ITEM,
	TRANSFORM_HEADINGS_H3_MENU_ITEM,
	TRANSFORM_HEADINGS_H4_MENU_ITEM,
	TRANSFORM_HEADINGS_H5_MENU_ITEM,
	TRANSFORM_HEADINGS_H6_MENU_ITEM,
	TRANSFORM_SUGGESTED_MENU_SECTION,
	TRANSFORM_STRUCTURE_MENU_SECTION,
	TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM,
	TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM,
	TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM,
	TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM,
	TRANSFORM_STRUCTURE_PANEL_MENU_ITEM,
	TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM,
	TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM,
	TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM,
	TRANSFORM_STRUCTURE_DECISION_MENU_ITEM,
	TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM,
	TRANSFORM_SUGGESTED_MENU_ITEM,
	TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM,
	AI_MENU_SECTION,
	AI_ASK_ROVO_MENU_ITEM,
} from './key';

export const MAIN_BLOCK_MENU_SECTION_RANK = {
	[TRANSFORM_MENU_SECTION.key]: 200,
	[AI_MENU_SECTION.key]: 250,
	[BLOCK_ACTIONS_MENU_SECTION.key]: 300,
	[POSITION_MENU_SECTION.key]: 400,
	[DELETE_MENU_SECTION.key]: 500,
};

export const AI_MENU_SECTION_RANK = {
	[AI_ASK_ROVO_MENU_ITEM.key]: 100,
};

export const TRANSFORM_MENU_SECTION_RANK = {
	[TRANSFORM_MENU_ITEM.key]: 100,
};

export const TRANSFORM_SUGGESTED_MENU_SECTION_RANK = {
	[TRANSFORM_SUGGESTED_MENU_ITEM.key]: 100,
};

export const TRANSFORM_MENU_ITEM_RANK = {
	[TRANSFORM_SUGGESTED_MENU_SECTION.key]: 100,
	[TRANSFORM_CREATE_MENU_SECTION.key]: 200,
	[TRANSFORM_STRUCTURE_MENU_SECTION.key]: 300,
	[TRANSFORM_HEADINGS_MENU_SECTION.key]: 400,
	[TRANSFORM_CLEAR_MENU_SECTION.key]: 500,
};

export const TRANSFORM_CREATE_MENU_SECTION_RANK = {
	[TRANSFORM_DEFAULT_EXTENSION_SLOT_MENU_ITEM.key]: 1000,
};

export const TRANSFORM_HEADINGS_MENU_SECTION_RANK = {
	[TRANSFORM_HEADINGS_H1_MENU_ITEM.key]: 100,
	[TRANSFORM_HEADINGS_H2_MENU_ITEM.key]: 200,
	[TRANSFORM_HEADINGS_H3_MENU_ITEM.key]: 300,
	[TRANSFORM_HEADINGS_H4_MENU_ITEM.key]: 400,
	[TRANSFORM_HEADINGS_H5_MENU_ITEM.key]: 500,
	[TRANSFORM_HEADINGS_H6_MENU_ITEM.key]: 600,
};

export const TRANSFORM_STRUCTURE_MENU_SECTION_RANK = {
	[TRANSFORM_STRUCTURE_BULLETED_LIST_MENU_ITEM.key]: 100,
	[TRANSFORM_STRUCTURE_TASK_LIST_MENU_ITEM.key]: 200,
	[TRANSFORM_STRUCTURE_NUMBERED_LIST_MENU_ITEM.key]: 300,
	[TRANSFORM_STRUCTURE_CODE_BLOCK_MENU_ITEM.key]: 400,
	[TRANSFORM_STRUCTURE_PANEL_MENU_ITEM.key]: 500,
	[TRANSFORM_STRUCTURE_EXPAND_MENU_ITEM.key]: 600,
	[TRANSFORM_STRUCTURE_LAYOUT_MENU_ITEM.key]: 700,
	[TRANSFORM_STRUCTURE_QUOTE_MENU_ITEM.key]: 800,
	[TRANSFORM_STRUCTURE_DECISION_MENU_ITEM.key]: 900,
	[TRANSFORM_STRUCTURE_PARAGRAPH_MENU_ITEM.key]: 1000,
};

export const TRANSFORM_CLEAR_MENU_SECTION_RANK = {
	[TRANSFORM_CLEAR_MENU_ITEM.key]: 100,
};

export const BLOCK_ACTIONS_MENU_SECTION_RANK = {
	[BLOCK_ACTIONS_CREATE_SYNCED_BLOCK_MENU_ITEM.key]: 100,
	[BLOCK_ACTIONS_FEATURED_EXTENSION_SLOT_MENU_ITEM.key]: 200,
	[BLOCK_ACTIONS_COPY_LINK_TO_BLOCK_MENU_ITEM.key]: 300,
};

export const POSITION_MENU_SECTION_RANK = {
	[POSITION_MOVE_UP_MENU_ITEM.key]: 100,
	[POSITION_MOVE_DOWN_MENU_ITEM.key]: 200,
};
export const DELETE_MENU_SECTION_RANK = {
	[DELETE_MENU_ITEM.key]: 100,
};
